import { Home, Search, LocationOn, Apartment, Euro } from '@mui/icons-material';
import { useEffect, useState } from 'react';

const PropertiesLoadingAnimation = () => {
    const [currentIcon, setCurrentIcon] = useState(0);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIcon((prev) => (prev + 1) % 4);
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const progressInterval = setInterval(() => {
            setProgress((prev) => {
                if (prev >= 95) return prev;
                return prev + Math.random() * 15;
            });
        }, 200);
        return () => clearInterval(progressInterval);
    }, []);

    const icons = [
        { icon: Search, color: '#3176BC', label: 'Searching properties', description: 'Scanning 950+ real estate agents' },
        { icon: LocationOn, color: '#4A90E2', label: 'Filtering by location', description: 'Finding properties in your area' },
        { icon: Apartment, color: '#6BA3E8', label: 'Analyzing listings', description: 'Checking property details & photos' },
        { icon: Euro, color: '#8BB6F0', label: 'Loading pricing data', description: 'Getting latest market prices' },
    ];

    return (
        <div className="flex flex-col items-center justify-center py-16">
            {/* Animated Icons */}
            <div className="relative flex items-center justify-center mb-8">
                <div className="relative w-20 h-20">
                    {icons.map((item, index) => {
                        const IconComponent = item.icon;
                        const isActive = index === currentIcon;
                        return (
                            <div
                                key={index}
                                className={`absolute inset-0 flex items-center justify-center transition-all duration-700 ${
                                    isActive ? 'opacity-100 scale-110' : 'opacity-30 scale-90'
                                }`}
                            >
                                <div className={`relative ${isActive ? 'animate-bounce' : ''}`}>
                                    <IconComponent
                                        style={{
                                            fontSize: '2.5rem',
                                            color: item.color,
                                            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.15))',
                                        }}
                                    />
                                    {isActive && <div className="absolute inset-0 bg-blue-200 rounded-full animate-ping opacity-30"></div>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Loading Text */}
            <div className="text-center mb-6">
                <div className="text-my-blue text-xl font-bold mb-2">{icons[currentIcon].label}...</div>
                <div className="text-gray-600 text-sm mb-1">{icons[currentIcon].description}</div>
                <div className="text-gray-500 text-xs">Please wait while we fetch the latest listings</div>
            </div>

            {/* Progress Bar */}
            <div className="w-64 h-2 bg-gray-200 rounded-full overflow-hidden shadow-inner">
                <div
                    className="h-full bg-gradient-to-r from-my-blue via-blue-400 to-blue-300 rounded-full transition-all duration-500 ease-out"
                    style={{
                        width: `${Math.min(progress, 95)}%`,
                        boxShadow: '0 0 15px rgba(49, 118, 188, 0.4)',
                    }}
                ></div>
            </div>

            {/* Progress Percentage */}
            <div className="mt-3 text-sm text-gray-500 font-medium">{Math.round(Math.min(progress, 95))}% complete</div>

            {/* Additional Info */}
            <div className="mt-6 text-center">
                <div className="text-xs text-gray-400 max-w-xs">Loading from the largest database of Mallorca properties</div>
            </div>
        </div>
    );
};

export default PropertiesLoadingAnimation;
